import { render, staticRenderFns } from "./LmAreas.vue?vue&type=template&id=19c8e475"
import script from "./LmAreas.vue?vue&type=script&lang=js"
export * from "./LmAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports